/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 14:36:42
 * @LastEditors: klcxkjhsm huangshimin@klcxkj.com
 * @LastEditTime: 2026-07-31 17:32:54
 * @FilePath: \app-client-h5\src\index.js
 */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import Vconsole from 'vconsole';
// const vConsole = new Vconsole()
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
